<!--
 * @Description: 客户账号详情-基本信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-02-24 15:56:35
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search">
    <detail-card
      :columns="columns"
      v-for="(item, index) in detail"
      :key="index"
      :title="`客户代码信息${index + 1}`"
      :data="item"
    >
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.dataIndex === 'subjectCount'">
          <a-button type="link" @click="linkToMainBody(record)"> {{ text || 0 }} </a-button>
        </template>
      </template>
    </detail-card>
    <dc-layout-empty type="nothing" v-if="!detail || !detail.length" />
  </a-form>
  <cos-footer-button :hideOk="true"> </cos-footer-button>
</template>
<script lang="ts">
import { onMounted, ref } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { queryCosArkCodeDeatil } from '@/api/gucangSales/customerCenter'
import { useRoute, useRouter } from 'vue-router'
import { CustomerCode } from '@/typings/api/customerCenter'
export default { name: 'TabsCode' }
</script>
<script setup lang="ts">
const route = useRoute()
const router = useRouter()
const detail = ref([])

const fetch = () => {
  queryCosArkCodeDeatil({
    cosId: route.query.cosId
  }).then((res) => {
    detail.value = res.data
  })
}
onMounted(() => {
  fetch()
})
const columns = ref([
  { title: '子客户代码', dataIndex: 'arkCode' },
  {
    title: '客户阶段',
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: '子客户代码名称', dataIndex: 'arkAccount' },
  { title: '档次', dataIndex: 'level' },
  { title: '联系人', dataIndex: 'arkContactName' },
  { title: '成交金额（万）', dataIndex: 'amount' },
  { title: '手机号', dataIndex: 'arkContactMobile' },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '创建时间', dataIndex: 'createTime' },
  {
    title: 'ark账号状态',
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  },
  {
    title: '主体数量',
    dataIndex: 'subjectCount'
  }
])
// 跳转到签约主体列表
const linkToMainBody = (row: CustomerCode) => {
  if (!row.subjectCount) {
    return
  }
  router.push({
    path: '/fbu/mainBody',
    query: {
      customerCode: row.arkCode
    }
  })
}
</script>

<style lang="scss" scoped></style>
